import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { get, set, find, clone, orderBy } from 'lodash'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col } from 'reactstrap'
import {
  modalAction,
  authAction,
  projectInformationAction,
  lobAction,
  companyAction,
  departmentAction,
  employeeAction,
  clientMasterAction,
  saleProductAction,
  projectCodeAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  projectInformationSelector,
  lobSelector,
  companySelector,
  departmentSelector,
  employeeSelector,
  clientMasterSelector,
  projectCodeSelector,
} from './../../selectors'
import {
  searchProjectInformation,
  createProjectApproverList,
  createClientList,
  createPMSupervisorList,
  createProjectManagerList,
  findNameByID,
  selectStatusWord,
} from '../../function'
import CustomModalMessage from '../../components/modal-message'
import ProjectCodeDetail from '../../components/project-code/project-detail'
import Searchbar from '../../components/project-code/searchbar'
import { project_type } from '../../components/project-information/constants'
import { ProjectTable } from '../../components/project-information/table'
import withLayout from '../../helpers/withLayout'

class ProjectCodePage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    const access_token = localStorage.getItem('access_token')
    if (get(nextProps, 'getProjectInformationData.projects') &&
    get(nextProps, 'getClientData') &&
    get(nextProps, 'getLOBData')) {
      const approverList = createProjectApproverList(get(nextProps, 'getProjectInformationData.users'))
      const supervisorList = createPMSupervisorList(get(nextProps, 'getProjectInformationData.users'))
      const managerList = createProjectManagerList(get(nextProps, 'getProjectInformationData.users'))

      const manager = find(managerList, {
        _id: get(nextProps, 'authData.user._id'),
      })

      if (manager !== undefined) set(tempState, 'project_managers', [manager])
      set(tempState, 'approvers', approverList)
      set(tempState, 'managers', managerList)
      set(tempState, 'pm_supervisors', supervisorList)

      const lobs = get(nextProps, 'getLOBData')
      if (lobs !== prevState.lobs) {
        set(tempState, 'lobs', orderBy(lobs, ['name'], ['asc']))
      }
      const clients = createClientList(get(nextProps, 'getClientData'))
      if (clients !== prevState.clients) {
        set(tempState, 'clients', clients)
      }
      const projects = []
      get(nextProps, 'getProjectInformationData.projects').map(p => {
        const project = {}
        project._id = p._id
        project.client = findNameByID(p.client_id, clients)
        project.name = p.name
        project.lob = findNameByID(p.lob_id, lobs)
        project.project_code = p.project_code
        project.start_date = moment(p.start_date).format('DD/MM/YYYY')
        project.default_start_date = moment(p.start_date).format('YYYY/MM/DD')
        project.end_date = moment(p.end_date).format('DD/MM/YYYY')
        project.default_end_date = moment(p.end_date).format('YYYY/MM/DD')
        project.key_project_manager = p.key_project_manager
        // project.project_manager = findProjectManagersByID(p.project_manager_ids, managerList)
        project.status = p.project_status
        project.created = moment(p.created)
        project.project_type = get(find(project_type, {
          value: p.project_type,
        }), 'label', '-')
        projects.push(project)
        return p
      })
      set(tempState, 'defaultProjectInformation', projects)
      set(tempState, 'projectInformation', projects)
      nextProps.resetGetProjectInformation()
    }
    if (get(nextProps, 'getProjectInformationByIDData.project')) {
      set(tempState, 'lobs', get(nextProps, 'getLOBData'))
      const approverList = createProjectApproverList(get(nextProps, 'getProjectInformationByIDData.users'))
      const supervisorList = createPMSupervisorList(get(nextProps, 'getProjectInformationByIDData.users'))
      const managersList = createProjectManagerList(get(nextProps, 'getProjectInformationByIDData.users'))
      const companys = orderBy(get(nextProps, 'getCompanyData'), ['name', ['asc']])
      const lobs = orderBy(get(nextProps, 'getLOBData'), ['name'], ['asc'])
      const departments = orderBy(get(nextProps, 'getDepartmentData'), ['name'], ['asc'])
      const approvers = []
      const managers = []
      const projectByID = get(nextProps, 'getProjectInformationByIDData.project')[0]
      const crType = get(nextProps, 'getProjectInformationByIDData.crType').map(t => {
        return {
          label: t.charAt(0).toUpperCase() + t.replace('_', ' ').substring(1).toLowerCase().replace('ma', 'MA'),
          value: t,
        }
      })
      projectByID.project_approver_ids.map(p => {
        const apr = find(approverList, {
          _id: p,
        })
        if (apr !== undefined) approvers.push(apr)
        return p
      })
      projectByID.project_manager_ids.map(m => {
        const mgr = find(managersList, {
          _id: m,
        })
        if (mgr !== undefined) managers.push(mgr)
        return m
      })
      const users = get(nextProps, 'getProjectInformationByIDData.users')
      const key_pm = users.find(u => u._id === projectByID.key_project_manager_id)
      set(tempState, 'users', users)
      set(tempState, 'project_approvers', approvers)
      set(tempState, 'project_managers', managers)
      set(tempState, 'pm_supervisors', supervisorList)
      set(tempState, 'project', projectByID)
      set(tempState, 'crType', crType)
      const otherCostByID = clone(projectByID.other_costs)
      projectByID.other_costs.map((o, key) => {
        if (o.cost_month.length === 0) {
          const cost_months = []
          let change_start_date = moment(projectByID.start_date)
          if (change_start_date !== '' && projectByID.end_date !== '') {
            for (; moment(change_start_date).isSameOrBefore(moment(projectByID.end_date)); change_start_date = moment(change_start_date).add(1, 'month')) {
              cost_months.push({ month: `${moment(change_start_date).format('YYYY')}-${moment(change_start_date).format('MM')}`, cost: 0 })
            }
          }
          otherCostByID[key].cost_month = cost_months
        }
        return o
      })
      set(tempState, 'project_type', get(find(project_type, {
        value: projectByID.project_type,
      }), 'label', '-'))
      set(tempState, 'project_name', projectByID.name)
      set(tempState, 'project_code', get(projectByID, 'project_code'))
      set(tempState, 'project_status', selectStatusWord(projectByID.project_status))
      set(tempState, 'key_pm', key_pm ? `${key_pm.emp_code} - ${key_pm.first_name} ${key_pm.last_name} (${key_pm.nick_name})` : '-')

      const clientList = createClientList(get(nextProps, 'getClientData'))
      const client = find(clientList, {
        _id: projectByID.client_id,
      })
      set(tempState, 'client', client)
      const pm_supervisor = find(supervisorList, {
        _id: projectByID.project_supervisor_id,
      })
      set(tempState, 'pm_supervisor', pm_supervisor)
      const company = find(companys, {
        _id: projectByID.company_id,
      })
      if (company) set(tempState, 'company', company.name)
      const lob = find(lobs, {
        _id: projectByID.lob_id,
      })
      if (lob) set(tempState, 'lob', lob.name)
      const department = find(departments, {
        _id: projectByID.department_id,
      })
      if (department) set(tempState, 'department', department.name)

      set(tempState, 'start_date', moment(projectByID.start_date))
      set(tempState, 'end_date', moment(projectByID.end_date))
      set(tempState, 'description', projectByID.description)
      nextProps.showModal('projectDetail')
      nextProps.resetGetProjectInformationByID()
    }
    if (get(nextProps, 'updatedProjectNonService.updatedProject')) {
      const status = get(nextProps, 'updatedProjectNonService.status')
      const message = get(nextProps, 'updatedProjectNonService.message')
      nextProps.getProjectInformation(access_token)
      nextProps.showConfirm('editSuccess', status, message)
      nextProps.resetEditProjectNonService()
    }
    if (get(nextProps, 'getCompanyData') !== prevState.companys) {
      set(tempState, 'companys', orderBy(get(nextProps, 'getCompanyData'), ['name'], ['asc']))
    }
    if (get(nextProps, 'getDepartmentData') !== prevState.departments) {
      set(tempState, 'departments', orderBy(get(nextProps, 'getDepartmentData'), ['name'], ['asc']))
    }

    if (nextProps.projectNonService) {
      set(tempState, 'projectNonService', nextProps.projectNonService)
      nextProps.resetGetProjectNonService()
    }
    return tempState
  }
  constructor(props) {
    super(props)
    this.projectCode = React.createRef()
    this.state = {
      redirect: false,
      projectID: '',
      rowID: '',
      defaultProjectInformation: [],
      projectInformation: [],
      project: null,
      selectedStatus: '',
      lobs: [],
      companys: [],
      departments: [],
      pm_supervisors: [],
      clients: [],
      search: '',
      sort_by: '',
      sort_order: 'asc',

      project_types: [],
      project_approvers: [],
      project_managers: [],
      project_type: '',
      client: '',
      project_name: '',
      project_code: '',
      pm_supervisor: '',
      company: '',
      lob: '',
      department: '',
      start_date: '',
      end_date: '',
      description: '',
      projectNonService: {},
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleProjectStatus = this.handleProjectStatus.bind(this)
    this.hideForm = this.hideForm.bind(this)
    this.handleCloseForm = this.handleCloseForm.bind(this)
    this.keyPress = this.keyPress.bind(this)
    this.sortBy = this.sortBy.bind(this)
    this.editProjectCode = this.editProjectCode.bind(this)
  }
  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    Promise.all([
      this.props.getProjectInformation(access_token),
      this.props.getLOB(access_token),
      this.props.getCompany(access_token),
      this.props.getDepartment(access_token),
      this.props.getClient(access_token),
      this.props.getSaleProduct(access_token),
    ])
  }
  sortBy(type, order) {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }
  sortProject(data) {
    if (this.state.sort_by === 'client') return orderBy(data, ['client'], [this.state.sort_order])
    else if (this.state.sort_by === 'name') return orderBy(data, ['name'], [this.state.sort_order])
    else if (this.state.sort_by === 'project_type') return orderBy(data, ['project_type'], [this.state.sort_order])
    else if (this.state.sort_by === 'lob') return orderBy(data, ['lob'], [this.state.sort_order])
    else if (this.state.sort_by === 'project_code') return orderBy(data, ['project_code'], [this.state.sort_order])
    else if (this.state.sort_by === 'start_date') return orderBy(data, ['start_date'], [this.state.sort_order])
    else if (this.state.sort_by === 'end_date') return orderBy(data, ['end_date'], [this.state.sort_order])
    else if (this.state.sort_by === 'project_manager') return orderBy(data, ['project_manager'], [this.state.sort_order])
    else if (this.state.sort_by === 'status') return orderBy(data, ['status'], [this.state.sort_order])
    return orderBy(data, ['created'], [this.state.sort_order])
  }
  handleClickRow(click, id, editID) {
    this.setState({
      isClick: click,
      projectID: id,
      rowID: editID,
      project: null,
    })
    const access_token = localStorage.getItem('access_token')
    this.props.getProjectInformationByID(id, access_token)
    this.props.getProjectNonService(id, access_token)
  }
  handleClickSearch() {
    let projectInfo = get(this.state, 'defaultProjectInformation')
    projectInfo = projectInfo.filter(searchProjectInformation, this.state.search)
    if (this.state.selectedStatus !== '') {
      projectInfo = projectInfo.filter((element) => {
        return element.status.toLowerCase() === this.state.selectedStatus.toLowerCase()
      })
    }
    this.setState({ projectInformation: projectInfo })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') {
      let projectInfo = get(this.state, 'defaultProjectInformation')
      if (this.state.selectedStatus !== '') {
        projectInfo = projectInfo.filter((element) => {
          return element.status.toLowerCase() === this.state.selectedStatus.toLowerCase()
        })
      }
      this.setState({
        projectInformation: projectInfo,
        search: '',
      })
    } else this.setState({ search: e.target.value })
  }
  handleProjectStatus(e) {
    let projectInfo = get(this.state, 'defaultProjectInformation')
    projectInfo = projectInfo.filter(searchProjectInformation, this.state.search)
    if (e.target.value !== '') {
      projectInfo = projectInfo.filter((element) => {
        return element.status.toLowerCase() === e.target.value.toLowerCase()
      })
    }
    this.setState({
      projectInformation: projectInfo,
      selectedStatus: e.target.value,
    })
  }
  handleCloseForm() {
    const textArea = (<div>
      <Modaltext>Are you sure you want to discard all changes ?</Modaltext>
    </div>)
    this.props.showConfirm('confirmClose', 'Cancel Project Information Form', textArea)
  }
  keyPress(e) {
    if (e.key === "Escape") this.handleCloseForm()
  }
  hideForm() {
    this.setState({ project_code: '' })
    this.props.hideModal('projectDetail')
    this.props.hideConfirm('confirmClose')
  }

  editProjectCode = async () => {
    const access_token = localStorage.getItem('access_token')
    const payload = this.projectCode.getProjectNonServiceState()
    await this.props.editProjectNonService(this.state.projectID, payload, access_token)
    this.props.hideModal('projectDetail')
    this.projectCode.resetTab()
  }

  render() {
    const { projectNonService } = this.state
    const projects = this.state.projectInformation
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectProject.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectProject.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsSystemUser !== undefined &&
      IsManagementUser !== undefined &&
      IsAccountantUser !== undefined &&
      !(IsSystemUser || IsManagementUser || IsAccountantUser)) window.location = '/home'

    const buttonOK = (type) => (
      <OKButton color="success" onClick={ () => this.props.hideConfirm(type) }>OK</OKButton>
    )
    const buttonTryAgain = (type) => (
      <OKButton color="warning" onClick={ () => this.props.hideConfirm(type) }>Try Again</OKButton>
    )
    const buttonYesNoClose = (
      <div>
        <OKButton color="" onClick={ () => this.props.hideConfirm('confirmClose') }>No</OKButton>
        <OKButton color="danger" onClick={ this.hideForm }>Yes</OKButton>
      </div>
    )
    const saveButton = (
      <div>
        <SaveButton color='success' onClick={ this.editProjectCode }>Save</SaveButton>
        <SaveButton onClick={ this.handleCloseForm }>Cancel</SaveButton>
      </div>
    )

    const isFetching = get(this.props, 'getIsFetchingCompany')
    || get(this.props, 'getIsFetchingLOB')
    || get(this.props, 'getIsFetchingEmployee')
    || get(this.props, 'getIsFetchingDepartment')
    || get(this.props, 'getIsFetchingClient')
    || get(this.props, 'getIsFetchingProject')
    || get(this.props, 'getIsFetchingProjectCode')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        {
          get(this.props, 'confirmType') === 'editSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm(get(this.props, 'confirmType')) }
              show={ get(this.props, 'confirmType') === 'editSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ get(this.props, 'confirmStatus') === 200 ? buttonOK(get(this.props, 'confirmType')) : buttonTryAgain(get(this.props, 'confirmType')) }
            />
        }
        {
          get(this.props, 'confirmType') === 'confirmClose' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('confirmClose') }
              show={ get(this.props, 'confirmType') === 'confirmClose' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonYesNoClose }
            />
        }
        <Searchbar
          handleSearch={ this.handleSearch }
          handleProjectStatus={ this.handleProjectStatus }
          { ...this.state }
        />
        <ProjectCodeDetail
          ref={ e => { this.projectCode = e } }
          isOpen={ get(this.props, 'modalType') === 'projectDetail' }
          actions={ saveButton }
          toggle={ this.handleCloseForm }
          data={ this.state }
          projectNonService={ projectNonService }
        />
        <Row noGutters>
          <Col>
            { isFetching &&
              <Overlay>
                <OverlayWrapper>
                  <BeatLoader
                    css={ css(`
                      position: absolute;
                      left: 50%;
                      top: 50%;
                    `) }
                    sizeUnit={ "px" }
                    size={ 15 }
                    color={ '#D44B49' }
                    loading={ isFetching }
                  />
                </OverlayWrapper>
              </Overlay>
            }
            <ProjectTable
              handleClickRow={ this.handleClickRow }
              sortBy={ this.sortBy }
              projects={ this.sortProject(projects) }
              { ...this.state }
            />
          </Col>
        </Row>
      </Wrapper>
    )
  }
}

ProjectCodePage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectProject: projectInformationSelector.redirectProject,
  getIsFetchingCompany: companySelector.getIsFetching,
  getIsFetchingLOB: lobSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getIsFetchingDepartment: departmentSelector.getIsFetching,
  getIsFetchingClient: clientMasterSelector.getIsFetching,
  getIsFetchingProject: projectInformationSelector.getIsFetching,
  getProjectInformationData: projectInformationSelector.getProjectInformationData,
  getProjectInformationByIDData: projectInformationSelector.getProjectInformationByIDData,
  editProjectInformationData: projectInformationSelector.editProjectInformationData,
  getLOBData: lobSelector.getListLOB,
  getCompanyData: companySelector.getListCompany,
  getDepartmentData: departmentSelector.getListDepartment,
  getEmployeeData: employeeSelector.getListUser,
  getClientData: clientMasterSelector.getClientData,
  getIsFetchingProjectCode: projectCodeSelector.getIsFetching,
  projectNonService: projectCodeSelector.getProjectNonService,
  updatedProjectNonService: projectCodeSelector.getUpdatedProjectNonService,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getProjectInformation: projectInformationAction.getProjectInformation,
  resetGetProjectInformation: projectInformationAction.resetGetProjectInformation,
  getProjectInformationByID: projectInformationAction.getProjectInformationByID,
  resetGetProjectInformationByID: projectInformationAction.resetGetProjectInformationByID,
  editProjectInformation: projectInformationAction.editProjectInformation,
  resetEditProjectInformation: projectInformationAction.resetEditProjectInformation,
  getLOB: lobAction.getLOB,
  getCompany: companyAction.getCompany,
  getDepartment: departmentAction.getDepartment,
  getEmployee: employeeAction.getUser,
  resetGetEmployee: employeeAction.resetListUser,
  getClient: clientMasterAction.getClient,
  getSaleProduct: saleProductAction.getSaleProduct,
  editProjectNonService: projectCodeAction.editProjectNonService,
  resetEditProjectNonService: projectCodeAction.resetEditProjectNonService,
  getProjectNonService: projectCodeAction.getProjectNonService,
  resetGetProjectNonService: projectCodeAction.resetGetProjectNonService,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ProjectCodePage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const SaveButton = styled(Button)`
  font-family: 'Gotham-Bold' !important;
  font-size: 15px ;
  margin-right: 10px;
`
const OKButton = styled(Button)`
  font-family: 'Gotham-Bold' !important;
  font-size: 15px ;
  margin-right: 10px;
`
const Modaltext = styled.p`
  font-family: 'Gotham' !important;
  font-size: 15px ;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`




// WEBPACK FOOTER //
// ./src/pages/project-code/index.js